<hyperkit-dialog class="hyperkit-component" headerText="Archive Hunt Template">
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        <hyperkit-typography variant="body" size="md" align="left" color="body">
          Are you sure you want to archive
          <strong>{{ huntTemplate.name }}</strong
          >?</hyperkit-typography
        >
        <!-- Checkbox for archiving hunts -->
        @if (huntTemplate.hunts?.length > 0) {
          <div class="checkbox-wrapper">
            <hyperkit-checkbox
              [(ngModel)]="nestedArchive"
              label="Archive all hunts referenced in this hunt
              template"
            >
            </hyperkit-checkbox>
          </div>
        }
        <hyperkit-button
          size="small"
          color="tertiary"
          text="Archive"
          (click)="onSubmit()"
        ></hyperkit-button>
      </div>
    </div>
  </div>
</hyperkit-dialog>
